export default "__VITE_ASSET__DdhnQ3ng__"